import React from 'react';
import {Typography} from '@material-ui/core';
import {HotkeyConfigurationType, HotkeyGroup} from '../HotkeyDialogTypes';
import './HotkeySection.scss';

const mapHotkeyCombo = (hotkeyCombo: string, index: number) => {
    return (
        <Typography
            variant="body2"
            key={hotkeyCombo}
            className={`key-combo${index > 0 ? ' margin-left' : ''}`}
        >
            {hotkeyCombo}
        </Typography>
    );
};

const hotkeyRow = (
    {keyCombo = [], description}: HotkeyConfigurationType,
    index: number
) => {
    const hotkeyCombos = keyCombo.map(mapHotkeyCombo);

    return (
        <div className="row" key={index}>
            <Typography variant="body2" className="description">
                {description}
            </Typography>
            {hotkeyCombos}
        </div>
    );
};

export interface HotkeySectionProps {
    groupedHotkeys: HotkeyConfigurationType[];
    section: HotkeyGroup;
}

export default function HotkeySection({
    groupedHotkeys = [],
    section,
}: HotkeySectionProps) {
    return (
        <div className="hotkey-section">
            <Typography variant="h5">{section}</Typography>
            {groupedHotkeys.map(hotkeyRow)}
        </div>
    );
}
